import styles from "./label.module.scss";

export default function Label(props: { text: string }) {
  return (
    <div>
      <h2 className={styles.labelStyle}>{props.text}</h2>
    </div>
  );
}
